export default __webpack_public_path__ + "static/media/arrow-back-to-coaches-switch.92b9f5df.svg";